import { Module } from "vuex";
import { RootState } from "@/store/type";
import { CategoryState } from "@/store/category/type";
import { getters } from "@/store/category/getters";
import { actions } from "@/store/category/actions";
import { mutations } from "@/store/category/mutations";

const state: CategoryState = {
  categoryTree: undefined,
  activeCategory: null,
};

export const category: Module<CategoryState, RootState> = {
  state,
  getters,
  mutations,
  actions,

};




